module.exports = __webpack_public_path__ + "img/button-app-store.479b4b80.png";